export default "__VITE_ASSET__D90Z725S__"